import React, { useState } from 'react';
// ====== constantes componentes ======
const SegundoComponente = ({ 
  onClose, 
  setAdminLogueado, 
  setUserLogueado, 
  setCurrentUser,
  setShowRegister, 
  setShowRecovery,
  setShowAppointment,
  showRegister, 
  showRecovery,
  loginData,
  setLoginData
  // ====== constante registro de datos ======
}) => {
  const [registerData, setRegisterData] = useState({ 
    identificacion: '',
    tipoIdentificacion: 'CC',
    nombre: '', 
    email: '', 
    password: '', 
    confirmPassword: '',
    celular: '',
    direccion: ''
  });
  const [recoveryData, setRecoveryData] = useState({ email: '' });

  const tiposIdentificacion = ['CC', 'CE', 'NIT', 'TI', 'PASAPORTE'];

  const handleLogin = (e) => {
    e.preventDefault();
    
    if (loginData.email === 'admin@mascoticas.com' && loginData.password === 'admin123') {
      setAdminLogueado(true);
      
      const logins = JSON.parse(localStorage.getItem('logins')) || [];
      logins.push({
        email: loginData.email,
        nombre: 'Administrador',
        contacto: 'N/A',
        fecha: new Date().toLocaleString('es-CO', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        }),
        tipo: 'admin'
      });
      localStorage.setItem('logins', JSON.stringify(logins));
      
      onClose();
      return;
    }
    
    const usuarios = JSON.parse(localStorage.getItem('usuarios')) || [];
    const usuario = usuarios.find(u => u.email === loginData.email && u.password === loginData.password);
    
    if (usuario) {
      setUserLogueado(true);
      setCurrentUser(usuario);
      
      const logins = JSON.parse(localStorage.getItem('logins')) || [];
      logins.push({
        usuarioId: usuario.id,
        identificacion: usuario.identificacion,
        nombre: usuario.nombre,
        email: usuario.email,
        contacto: usuario.celular,
        fecha: new Date().toLocaleString('es-CO', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        }),
        tipo: 'login'
      });
      localStorage.setItem('logins', JSON.stringify(logins));
      
      alert('Inicio de sesión exitoso');
      onClose();
    } else {
      alert('Credenciales incorrectas');
    }
  };

  const handleRegister = (e) => {
    e.preventDefault();
    
    if (registerData.password !== registerData.confirmPassword) {
      alert('Las contraseñas no coinciden');
      return;
    }
    
    const usuarios = JSON.parse(localStorage.getItem('usuarios')) || [];
    const identificacionExistente = usuarios.some(u => u.identificacion === registerData.identificacion);
    
    if (identificacionExistente) {
      alert('Ya existe un usuario con esta identificación');
      return;
    }
    
    const nuevoUsuario = {
      id: Date.now(),
      identificacion: registerData.identificacion,
      tipoIdentificacion: registerData.tipoIdentificacion,
      nombre: registerData.nombre,
      email: registerData.email,
      password: registerData.password,
      celular: registerData.celular,
      contacto: registerData.celular,
      direccion: registerData.direccion,
      fechaRegistro: new Date().toLocaleString('es-CO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      })
    };
    
    usuarios.push(nuevoUsuario);
    localStorage.setItem('usuarios', JSON.stringify(usuarios));
    
    const logins = JSON.parse(localStorage.getItem('logins')) || [];
    logins.push({
      usuarioId: nuevoUsuario.id,
      identificacion: nuevoUsuario.identificacion,
      nombre: nuevoUsuario.nombre,
      email: nuevoUsuario.email,
      contacto: nuevoUsuario.celular,
      fecha: new Date().toLocaleString('es-CO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      }),
      tipo: 'registro'
    });
    localStorage.setItem('logins', JSON.stringify(logins));
    
    alert('Registro exitoso. Ahora puedes iniciar sesión');
    setShowRegister(false);
    setLoginData({ ...loginData, email: registerData.email });
    setRegisterData({ 
      identificacion: '',
      tipoIdentificacion: 'CC',
      nombre: '', 
      email: '', 
      password: '', 
      confirmPassword: '',
      celular: '',
      direccion: ''
    });
  };
// ====== constante recuperacion======
  const handleRecovery = (e) => {
    e.preventDefault();
    alert(`Se ha enviado un enlace de recuperación a ${recoveryData.email}`);
    setShowRecovery(false);
    setRecoveryData({ email: '' });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRegisterData(prev => ({ ...prev, [name]: value }));
  };

  const styles = {
    container: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      padding: '2rem',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      width: '90%',
      maxWidth: '400px',
      zIndex: 1000
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    },
    heading: {
      textAlign: 'center',
      marginBottom: '1rem',
      color: '#333'
    },
    input: {
      padding: '0.75rem',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '1rem'
    },
    select: {
      padding: '0.75rem',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '1rem',
      backgroundColor: 'white'
    },
    formActions: {
      display: 'flex',
      gap: '1rem',
      marginTop: '1rem'
    },
    primaryButton: {
      backgroundColor: '#007bff',
      color: 'white',
      border: 'none',
      padding: '0.75rem',
      borderRadius: '4px',
      cursor: 'pointer',
      flex: 1,
      fontSize: '1rem'
    },
    secondaryButton: {
      backgroundColor: '#6c757d',
      color: 'white',
      border: 'none',
      padding: '0.75rem',
      borderRadius: '4px',
      cursor: 'pointer',
      flex: 1,
      fontSize: '1rem'
    },
    appointmentButton: {
      backgroundColor: '#28a745',
      color: 'white',
      border: 'none',
      padding: '0.75rem',
      borderRadius: '4px',
      cursor: 'pointer',
      flex: 1,
      fontSize: '1rem',
      marginTop: '1rem'
    },
    formLinks: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '1rem'
    },
    linkButton: {
      background: 'none',
      border: 'none',
      color: '#007bff',
      cursor: 'pointer',
      textDecoration: 'underline',
      padding: 0,
      fontSize: '0.9rem'
    },
    inputGroup: {
      display: 'flex',
      gap: '0.5rem'
    }
  };

  return (
    <div style={styles.container}>
      {!showRegister && !showRecovery ? (
        <form style={styles.form} onSubmit={handleLogin}>
          <h2 style={styles.heading}>Iniciar Sesión</h2>
          <input 
            type="email" 
            placeholder="Correo electrónico" 
            value={loginData.email}
            onChange={(e) => setLoginData({...loginData, email: e.target.value})}
            required
            style={styles.input}
          />
          <input 
            type="password" 
            placeholder="Contraseña" 
            value={loginData.password}
            onChange={(e) => setLoginData({...loginData, password: e.target.value})}
            required
            style={styles.input}
          />
          <div style={styles.formActions}>
            <button type="submit" style={styles.primaryButton}>Ingresar</button>
            <button type="button" style={styles.secondaryButton} onClick={onClose}>Cancelar</button>
          </div>
          <div style={styles.formLinks}>
            <button 
              type="button" 
              style={styles.linkButton}
              onClick={() => { setShowRecovery(true); setShowRegister(false); }}
            >
              ¿Olvidaste tu contraseña?
            </button>
            <button 
              type="button" 
              style={styles.linkButton}
              onClick={() => { setShowRegister(true); setShowRecovery(false); }}
            >
              Registrarse
            </button>
          </div>
          <button 
            type="button" 
            style={styles.appointmentButton}
            onClick={() => { setShowAppointment(true); onClose(); }}
          >
            
            Agendar Cita
          </button>
        </form>
      ) : showRegister ? (
        <form style={styles.form} onSubmit={handleRegister}>
          <h3 style={styles.heading}>Registro de Usuario</h3>
          
          <div style={styles.inputGroup}>
            <select
              name="tipoIdentificacion"
              value={registerData.tipoIdentificacion}
              onChange={handleInputChange}
              style={{ ...styles.select, flex: 1 }}
            >
              {tiposIdentificacion.map(tipo => (
                <option key={tipo} value={tipo}>{tipo}</option>
              ))}
            </select>
            <input
              type="text"
              name="identificacion"
              placeholder="Número de identificación"
              value={registerData.identificacion}
              onChange={handleInputChange}
              required
              style={{ ...styles.input, flex: 2 }}
            />
          </div>
          
          <input 
            type="text" 
            name="nombre"
            placeholder="Nombres completos" 
            value={registerData.nombre}
            onChange={handleInputChange}
            required
            style={styles.input}
          />
          <input 
            type="email" 
            name="email"
            placeholder="Correo electrónico" 
            value={registerData.email}
            onChange={handleInputChange}
            required
            style={styles.input}
          />
          <input 
            type="tel" 
            name="celular"
            placeholder="Celular" 
            value={registerData.celular}
            onChange={handleInputChange}
            required
            style={styles.input}
          />
          <input 
            type="text" 
            name="direccion"
            placeholder="Dirección" 
            value={registerData.direccion}
            onChange={handleInputChange}
            style={styles.input}
          />
          <input 
            type="password" 
            name="password"
            placeholder="Contraseña" 
            value={registerData.password}
            onChange={handleInputChange}
            required
            style={styles.input}
          />
          <input 
            type="password" 
            name="confirmPassword"
            placeholder="Confirmar contraseña" 
            value={registerData.confirmPassword}
            onChange={handleInputChange}
            required
            style={styles.input}
          />
          
          <div style={styles.formActions}>
            <button type="submit" style={styles.primaryButton}>Registrarse</button>
            <button 
              type="button" 
              style={styles.secondaryButton} 
              onClick={() => setShowRegister(false)}
            >
              Volver
            </button>
          </div>
        </form>
      ) : (
        <form style={styles.form} onSubmit={handleRecovery}>
          <h3 style={styles.heading}>Recuperar Contraseña</h3>
          <input 
            type="email" 
            placeholder="Correo electrónico" 
            value={recoveryData.email}
            onChange={(e) => setRecoveryData({email: e.target.value})}
            required
            style={styles.input}
          />
          <div style={styles.formActions}>
            <button type="submit" style={styles.primaryButton}>Enviar enlace</button>
            <button 
              type="button" 
              style={styles.secondaryButton} 
              onClick={() => setShowRecovery(false)}
            >
              Volver
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default SegundoComponente;